import "%modules%/header/header";
import "%modules%/contact/contact";
import "%modules%/form/form";
import "%modules%/select2/select2";
import "%modules%/tab/tab";
import "%modules%/history/history";
import "%modules%/modal/modal";
import "%modules%/in-stock/in-stock";
